import React from "react";
import { useLocation, Link } from "react-router-dom";
import { GET_LABELS } from "../hooks/useInventory";
import URI from "urijs";
import { useQuery } from "@apollo/client";
import useResponsive from "../hooks/useResponsive";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Store } from "../store";
import Meta from "../components/meta";

const Labels = () => {
  const { isMobile } = useResponsive();
  const config = Store.useState(s => s.config);

  const location = useLocation();
  const search = new URI(location.pathname + location.search).search(true);
  const letter = search.letter || "a";

  const { loading, data } = useQuery(GET_LABELS, { variables: { letter } });
  const labels = data && data.labels;

  const missingImage = config.getProperty("designs", "missingImageUri");

  const letters = ["0-9"];
  for (let i = 0; i < 26; i++) letters.push(String.fromCharCode(97 + i));
  letters.push("~");

  return (
    <div id="labels" className={isMobile ? "mobile" : ""}>
      <Meta title="Labels" noIndex={true} />
      <div className="header">
        <h1>Labels</h1>
        <div className="abecedaire">
          {letters.map(l => (
            <Link
              key={l}
              className={`${l === letter ? "active" : ""}`}
              to={new URI(location.pathname).setSearch({ letter: l }).toString()}>
              {l}
            </Link>
          ))}
        </div>
      </div>
      {!loading && labels ? (
        <div className="content">
          {labels.map(e => (
            <div key={e.id} className="entry">
              <Link className="name" to={`/catalogue?labels=${e.id}&stock=all`}>
                <div className="img">
                  <LazyLoadImage
                    alt={e.name}
                    src={e.images[0]?.uri || missingImage}
                  />
                </div>{" "}
              </Link>
              <p>{e.name} </p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

const Routes = [{
  path: "/catalogue/labels",
  element: <Labels />
}];

export default Labels;
export { Routes };
